var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopupCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EEFF5076-B513-4A67-A641-2C6FB98B8FAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.1-Mojo-SignIn-popup",
    transform: "translate(-1093.000000, -262.000000)",
    fill: "#004093",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup",
    transform: "translate(295.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup_close_icon",
    transform: "translate(778.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2843055,7.58859116 L8.35355339,7.64644661 L16,15.293 L23.6464466,7.64644661 C23.8417088,7.45118446 24.1582912,7.45118446 24.3535534,7.64644661 C24.5271197,7.82001296 24.5464049,8.08943736 24.4114088,8.2843055 L24.3535534,8.35355339 L16.707,16 L24.3535534,23.6464466 C24.5488155,23.8417088 24.5488155,24.1582912 24.3535534,24.3535534 C24.179987,24.5271197 23.9105626,24.5464049 23.7156945,24.4114088 L23.6464466,24.3535534 L16,16.707 L8.35355339,24.3535534 C8.15829124,24.5488155 7.84170876,24.5488155 7.64644661,24.3535534 C7.47288026,24.179987 7.45359511,23.9105626 7.58859116,23.7156945 L7.64644661,23.6464466 L15.293,16 L7.64644661,8.35355339 C7.45118446,8.15829124 7.45118446,7.84170876 7.64644661,7.64644661 C7.82001296,7.47288026 8.08943736,7.45359511 8.2843055,7.58859116 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupCloseIcon);
export default __webpack_public_path__ + "static/media/popup-close-icon.8467096b79abe1d3089aba1f172f5fa1.svg";
export { ForwardRef as ReactComponent };